export default class CustomDrawControls {
    _container;
    _draw;

    constructor(draw) {
        this._draw = draw;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        this._container.addEventListener('contextmenu', e => e.preventDefault());

        // eslint-disable-next-line no-unused-vars
        const select = this._buildControl('mapboxgl-ctrl-draw-select', e => {
            this._draw.changeMode('simple_select');
        });
        // eslint-disable-next-line no-unused-vars
        const polygon = this._buildControl(
            'mapboxgl-ctrl-draw-polygon mapboxgl-ctrl-new-shape',
            // eslint-disable-next-line no-unused-vars
            e => {
                this._draw.changeMode('draw_polygon');
            },
        );
        // eslint-disable-next-line no-unused-vars
        const rectangle = this._buildControl(
            'mapboxgl-ctrl-draw-rectangle mapboxgl-ctrl-new-shape',
            // eslint-disable-next-line no-unused-vars
            e => {
                this._draw.changeMode('draw_rectangle');
            },
        );
        // eslint-disable-next-line no-unused-vars
        const circle = this._buildControl(
            'mapboxgl-ctrl-draw-circle mapboxgl-ctrl-new-shape',
            // eslint-disable-next-line no-unused-vars
            e => {
                this._draw.changeMode('draw_circle');
            },
        );
        // eslint-disable-next-line no-unused-vars
        const trash = this._buildControl('mapboxgl-ctrl-delete-shape', e => {
            const selection = this._draw.getSelectedIds();

            if (selection && selection.length > 0) {
                this._draw.trash();
            } else {
                this._draw.deleteAll();
                this._map.fire('draw.delete', { features: [] });
            }
        });

        this._container.append(select);
        this._container.append(polygon);
        this._container.append(rectangle);
        this._container.append(circle);
        this._container.append(trash);
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._container = undefined;
        this.map = undefined;
        this._draw = undefined;
    }

    /**
     * Build a button control element.
     *
     * @param className - Classname for the control button
     * @param onClick - Click listener
     * @private
     */
    _buildControl(className, onClick) {
        let element = document.createElement('button');
        element.className = className;
        element.innerHTML = '<span class="mapboxgl-ctrl-icon" aria-hidden="true"></span>';
        element.addEventListener('click', onClick);
        return element;
    }
}
